const HERB_AGENCY_BASE_URL = "https://www.herb.agency";

const defaultParams = {
  utm_source: "herb.co",
  utm_medium: "internal",
  utm_campaign: "website_referral"
};

export const buildHerbAgencyUrl = ({
  path = "/lets-talk",
  utmContent
} = {}) => {
  const url = new URL(path, HERB_AGENCY_BASE_URL);

  Object.entries(defaultParams).forEach(([key, value]) => {
    url.searchParams.set(key, value);
  });

  if (utmContent) {
    url.searchParams.set("utm_content", utmContent);
  }

  return url.toString();
};
